/**
 * Feature flags for the signup flow.
 *
 * Lives in its own dependency-free module so it can be imported from both the client bundle
 * (via SignupStepContext) and the server-side step machine (SIGNUP_STEPS) without dragging
 * either graph into the other.
 */
export const enableSetHomeLocation: boolean = true;
